class AccessoryModel {
  constructor(obj) {
    this.id = null;
    this.title = null;
    this.description = null;
    this.vendor_code = null;
    this.price = null;
    this.availability_status = null;
    this.category_id = null;
    this.created_at = null;
    this.updated_at = null;
    this.deleted_at = null;

    this.image_urls = [];
    this.comment = null;

    this.status = null;

    if (obj) {
      Object.assign(this, obj);
    }
  }

  get dto() {
    return {
      ...this,
      status_id: this.status ? this.status.id : null,
    };
  }
}

export default AccessoryModel;
